/**
 * ListFactory
 */
import List from './List';
import EventList from './EventList';

class ListFactory {
	constructor( node: any, options: any ) {

		if ( options.board === 'eventlist_closed' || options.board === 'eventlist_running' ) {
			return new EventList( node, options );
		}

		return new List( node, options );
	}
}

export default ListFactory;
